module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "epub:type": "toc",
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "Chapter-Headers"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "epub:type": "toc",
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "Contents top1"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook3#_idTextAnchor001"
    }
  }, [_vm._v("Foreword by Dr. Harry Dumay, Elms President")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook4#_idTextAnchor003"
    }
  }, [_vm._v("Introduction by Father Mark S. Stelzer, STD")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Subhead"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook5#_idTextAnchor004"
    }
  }, [_vm._v("Part One")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook6#_idTextAnchor005"
    }
  }, [_vm._v("Original Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook7#_idTextAnchor006"
    }
  }, [_vm._v("First Mass—Father Francis Reilly")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook8#_idTextAnchor007"
    }
  }, [_vm._v("25th Anniversary of Ordination—Father Leo O’Neill")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook9#_idTextAnchor008"
    }
  }, [_vm._v("Liturgy of Christian Burial—Sister Thomasine O’Connor, SNDdeN")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook10#_idTextAnchor009"
    }
  }, [_vm._v("National Honor Society "), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("I")]), _vm._v("nduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook11#_idTextAnchor010"
    }
  }, [_vm._v("150th Anniversary—Sisters of Notre Dame de Namur")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook12#_idTextAnchor011"
    }
  }, [_vm._v("Day of Recollection for Priests")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook13#_idTextAnchor012"
    }
  }, [_vm._v("Christmas")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook14#_idTextAnchor013"
    }
  }, [_vm._v("Celebration of Special Anniversaries—Sisters of St. Joseph")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook15#_idTextAnchor014"
    }
  }, [_vm._v("Retreat Conference")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook16#_idTextAnchor015"
    }
  }, [_vm._v("Liturgy of Christian Burial—Nora Brosnan Crean")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook17#_idTextAnchor016"
    }
  }, [_vm._v("First Mass—Father Christopher Connelly")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook18#_idTextAnchor017"
    }
  }, [_vm._v("Liturgy of Christian Burial—William “Bill” Crean")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook19#_idTextAnchor018"
    }
  }, [_vm._v("Saint Patrick’s Day Mass")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook20#_idTextAnchor019"
    }
  }, [_vm._v("Saint Jude Novena")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook21#_idTextAnchor020"
    }
  }, [_vm._v("A Letter to His Nephew")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook22#_idTextAnchor021"
    }
  }, [_vm._v("Liturgy of Christian Burial—Father Cyril Burns")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook23#_idTextAnchor022"
    }
  }, [_vm._v("Farewell Mass")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook24#_idTextAnchor023"
    }
  }, [_vm._v("100th Anniversary—Saint Mary’s School")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook25#_idTextAnchor024"
    }
  }, [_vm._v("Liturgy of Christian Burial—Father John Johnson")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook26#_idTextAnchor025"
    }
  }, [_vm._v("Month’s Mind Mass—Monsignor Thomas Devine")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook27#_idTextAnchor026"
    }
  }, [_vm._v("Easter Vigil—2002")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook28#_idTextAnchor027"
    }
  }, [_vm._v("Liturgy of Christian Burial—Sister Helen Elizabeth")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook29#_idTextAnchor028"
    }
  }, [_vm._v("Liturgy of Christian Burial—Monsignor John Harrington")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook30#_idTextAnchor029"
    }
  }, [_vm._v("Special Anniversaries—Sisters of Providence")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook31#_idTextAnchor030"
    }
  }, [_vm._v("Christmas Letter to the Andrews Family")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook32#_idTextAnchor031"
    }
  }, [_vm._v("Last Will and Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Subhead"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook33#_idTextAnchor032"
    }
  }, [_vm._v("Part  Two")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook34#_idTextAnchor033"
    }
  }, [_vm._v("The Creans, Westfield, and Saint Mary’s Parish, by Jane F. Morrissey, SSJ, PhD")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook35#_idTextAnchor034"
    }
  }, [_vm._v("Reflections on American Catholic History")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook36#_idTextAnchor036"
    }
  }, [_vm._v("Roots and Realities of a Priestly People")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook37#_idTextAnchor037"
    }
  }, [_vm._v("Father Hugh Crean:Master Builder of Bridges, by Mary B. Johnson, SNDdeN, PhD")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook38#_idTextAnchor038"
    }
  }, [_vm._v("Shadow and Light, Doubt and Faith: Signs of the Sacred, by Peter A. DePergola III, PhD")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook39#_idTextAnchor039"
    }
  }, [_vm._v("Priesthood: A Sacrament of Friendship")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook40#_idTextAnchor041"
    }
  }, [_vm._v("Afterword by Hugh Andrews")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook41#_idTextAnchor042"
    }
  }, [_vm._v("Contributor Biographies")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook42#_idTextAnchor043"
    }
  }, [_vm._v("Appendix")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "href": "#/AlongTheWay_ebook43#_idTextAnchor044"
    }
  }, [_vm._v("Inspiring Words fromFather Hugh F. Crean")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70be16e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AlongTheWay_ebook-2.vue
// module id = 63
// module chunks = 0